/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import grafanaLogo from '@/assets/grafana/Grafana_logo.svg'
import powerBILogo from '@/assets/msft/Power_BI_Logo.svg'

const handleStyleLeft = { left: -2, top: 44 }

function ReportingNode({ data, isConnectable }) {
  const plcLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return powerBILogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return grafanaLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return grafanaLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return grafanaLogo
    }
  }
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={plcLogo()} alt="PLC Logo" className="custom-node-plc-icon" />
          </div>
          <div className="text-center">
            <b>Reporting</b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportingNode
